import React from "react";
import { GoTriangleUp } from "react-icons/go";
import { connect } from "react-redux";
import "./sub-banner.scss";

interface SubBannerProps {
  settings: any;
}

const SubBanner = ({ settings }: SubBannerProps) => {
  const movingBannerText = settings?.movingBannerText || "";
  const texts = movingBannerText ? movingBannerText.split(',').map((text: string) => text.trim()) : [];

  return (
    <div className='scroll-banner-container'>
      <div className='scroll-text'>
        {texts.map((text: string, i: number) => (
          <span key={i} className='scroll-item'>
            <span>{text}</span> <GoTriangleUp />
          </span>
        ))}
        {texts.map((text: string, i: number) => (
          <span key={`repeat-${i}`} className='scroll-item'>
            <span>{text}</span> <GoTriangleUp />
          </span>
        ))}
      </div>
    </div>
  );
};

const mapStateToProps = (state: any) => ({
  settings: state.settings
});

export default connect(mapStateToProps)(SubBanner);
